import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import "./View.css";
import jobImageOne from "../../../../Images/job-1.png";
import jobImageTwo from "../../../../Images/job-2.png";
import tempOne from "../../../../Images/t1.jpg";
import Breadcrumb from "../../../Layout/Breadcrumb/Breadcrumb";
import Header from "../../../Layout/Header/Header";
import Footer from "../../../Layout/Footer/Footer";
import Nav from "../../../Layout/Nav/Nav";
// import { useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import ButtonCall from "../../UiSpecification/Button/Button";
import UnLinkButton from "../../UiSpecification/UnLinkButton/UnLinkButton";
import ActionButtonCall from "../../UiSpecification/ActionButton/ActionButton";

import { MasterData } from "../../../Helpers/Data/MasterData/MasterData";
import { CatMasterData } from "../../../Helpers/Data/CatMasterData/CatMasterData";
import { Company } from "../../../Helpers/Data/Company/Company";
import { Contact } from "../../../Helpers/Data/Contact/Contact";
import { Unit } from "../../../Helpers/Data/Unit/Unit";

import sitelogo from "../../../../Images/logo.png";

import DataTable, { createTheme } from "react-data-table-component";

function InvoiceView() {
  return (
    <div className="page-con">
      <div>
        {/* <a
          href="http://localhost/smart-ebookings/Ref/print_cards?type=invoice&code=hHJwiMpK3Fcf7vB6YlCb15aPjnr9zgmd"
          title="Click to print this page"
          target="_BLANK"
        >
          <div className="print-btn example-print hvr-bob">
            <span className="print-icon">
              <i className="fa fa-print" aria-hidden="true" />
            </span>
            &nbsp; <span className="print-hide">Print this page</span>
          </div>
        </a>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n        @media(max-width:991px) {\n            .common_template_container {\n                width: calc(100% - 14px) !important;\n                padding: 7px !important;\n            }\n        }\n    ",
          }}
        /> */}
        <div
          className="common_template_container"
          style={{
            marginTop: "64px",
            width: "65%",
            display: "table",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td
                  style={{ width: "70%", marginRight: "2.5%", padding: "0px" }}
                  align="left"
                  valign="top"
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td
                          valign="top"
                          align="left"
                          style={{ paddingRight: "12px", height: "80px" }}
                        >
                          <img
                            src={sitelogo}
                            alt="Dewpoint Heating & Air Conditioning"
                            style={{
                              maxHeight: "65px",
                              width: "auto",
                              height: "100%",
                            }}
                          />
                        </td>
                        <td
                          valign="top"
                          align="left"
                          style={{ width: "100%", paddingRight: "22px" }}
                        >
                          <h1
                            style={{
                              marginTop: "0px",
                              marginBottom: "0px",
                              fontSize: "22px",
                              fontWeight: "700",
                            }}
                          >
                            Dewpoint
                          </h1>
                          <h4
                            style={{
                              marginTop: "3px",
                              marginBottom: "5px",
                              fontSize: "13px",
                              fontWeight: "700",
                            }}
                          >
                            1834 N Fairview St, Burbank, CA 91505
                          </h4>
                          <h4
                            style={{
                              marginTop: "3px",
                              marginBottom: "5px",
                              fontSize: "13px",
                              fontWeight: "700",
                            }}
                          >
                            213-479-5560 | info@dewpointheatingandac.com
                          </h4>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{ width: "25%", marginLeft: "2.5%" }}
                  align="right"
                  valign="top"
                >
                  <h1
                    style={{
                      marginTop: "0px",
                      marginBottom: "0px",
                      lineHeight: "18px",
                    }}
                  >
                    <div
                      style={{
                        textTransform: "uppercase",
                        fontWeight: 900,
                        fontSize: "26px",
                        lineHeight: "26px",
                        backgroundColor: "#399BFF",
                        color: "white",
                        display: "inline-block",
                        padding: "5px 9px",
                        marginBottom: "3px",
                      }}
                    >
                      Invoice
                    </div>
                    <br />
                    <div
                      style={{
                        textTransform: "uppercase",
                        fontWeight: 700,
                        fontSize: "18px",
                        lineHeight: "18px",
                        display: "inline-block",
                      }}
                    >
                      INV/25/01/37
                    </div>
                  </h1>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            className="common_template_body_container"
            style={{ marginTop: "8px" }}
          >
            <table
              style={{
                marginTop: "0px",
                width: "100%",
                fontSize: "13px",
                fontFamily: "Arial",
              }}
            >
              <tbody>
                <tr style={{ width: "100%" }}>
                  <td style={{ width: "45%", paddingRight: "5%" }} valign="top">
                    <table
                      style={{
                        marginBottom: "6px",
                        width: "100%",
                        backgroundColor: "#399BFF",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textTransform: "uppercase",
                              width: "100%",
                              fontSize: "15px",
                              color: "white",
                              fontWeight: 600,
                              padding: "1px 6px",
                              letterSpacing: "0.3px",
                            }}
                          >
                            Custome Details
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <table style={{ width: "100%" }}>
                      <tbody>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            style={{
                              textIndent: "9px",
                              width: "100%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            {" "}
                            Mohammed Rahmy Mohammed{" "}
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            style={{
                              textIndent: "9px",
                              width: "100%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            Address Line 01
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            style={{
                              textIndent: "9px",
                              width: "100%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            Address Line 01
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            style={{
                              textIndent: "9px",
                              width: "100%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            Address Line 03
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            style={{
                              textIndent: "9px",
                              width: "100%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            Address Line 04
                          </td>
                        </tr>
                      </tbody>
                    </table> */}
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            COMPANY
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">Las Ventanas</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            CONTACT
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">Strathern Park</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            LOCATION
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">
                                  11111 Strathern Street, Sun Valley.
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            PHONE
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">234-479-5555</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            EMAIL
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">strathern23@gmail.com</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td style={{ width: "45%", paddingLeft: "5%" }} valign="top">
                    <table
                      style={{
                        marginBottom: "6px",
                        width: "100%",
                        backgroundColor: "#399BFF",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textTransform: "uppercase",
                              width: "100%",
                              fontSize: "15px",
                              color: "white",
                              fontWeight: 600,
                              padding: "1px 6px",
                              letterSpacing: "0.3px",
                            }}
                          >
                            {/*Ship To*/}
                            Technician Details
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            NAME
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">Recusandae Itaque</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            CODE
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">T024</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            JOB TYPE
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">AC Technician, Electrician</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            PHONE
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">765-479-4444</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr style={{ fontSize: "13px" }}>
                          <td
                            valign="top"
                            style={{
                              textIndent: "9px",
                              width: "40%",
                              fontSize: "13px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 500,
                              letterSpacing: "0.3px",
                            }}
                          >
                            EMAIL
                          </td>
                          <td
                            valign="top"
                            style={{
                              width: "60%",
                              fontSize: "15px",
                              lineHeight: "18px",
                              paddingBottom: "3px",
                              color: "black",
                              fontWeight: 600,
                              letterSpacing: "0.3px",
                            }}
                          >
                            <table>
                              <tr>
                                <td valign="top">:&nbsp;</td>

                                <td valign="top">recusandaeiq@gmail.com</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              style={{
                borderColor: "#399BFF",
                marginTop: "20px",
                marginBottom: "20px",
                fontSize: "13px",
                width: "100%",
                borderCollapse: "collapse",
              }}
              cellSpacing="4.8px;"
              border={1}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      padding: "3px",
                      fontSize: "13px",
                      textTransform: "uppercase",
                      textAlign: "center",
                      backgroundColor: "#edf6ff",
                      fontWeight: "600",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                  >
                    Job Code
                  </td>
                  <td
                    style={{
                      padding: "3px",
                      fontSize: "13px",
                      textTransform: "uppercase",
                      textAlign: "center",
                      backgroundColor: "#edf6ff",
                      fontWeight: "600",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                  >
                    Date
                  </td>
                  <td
                    style={{
                      padding: "3px",
                      fontSize: "13px",
                      textTransform: "uppercase",
                      textAlign: "center",
                      backgroundColor: "#edf6ff",
                      fontWeight: "600",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                  >
                    Category
                  </td>
                  <td
                    style={{
                      padding: "3px",
                      fontSize: "13px",
                      textTransform: "uppercase",
                      textAlign: "center",
                      backgroundColor: "#edf6ff",
                      fontWeight: "600",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                  >
                    Invoice Status
                  </td>
                  {/* <td
                    style={{
                      padding: "3px",
                      fontSize: "13px",
                      textTransform: "uppercase",
                      textAlign: "center",
                      backgroundColor: "#edf6ff",
                      fontWeight: "600",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                  >
                    Booking Type
                  </td> */}
                </tr>
                <tr>
                  <td
                    style={{
                      padding: "3px",
                      fontSize: "14px",
                      paddingTop: "5px",
                      position: "relative",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                    align="center"
                  >
                    <strong>J001 </strong>
                  </td>
                  <td
                    style={{
                      padding: "3px",
                      fontSize: "14px",
                      paddingTop: "5px",
                      position: "relative",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                    align="center"
                  >
                    <strong>12/22/24 </strong>
                  </td>
                  <td
                    style={{
                      padding: "3px",
                      fontSize: "14px",
                      paddingTop: "5px",
                      position: "relative",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                    align="center"
                  >
                    <strong>AC </strong>
                  </td>
                  <td
                    style={{
                      padding: "3px",
                      fontSize: "14px",
                      paddingTop: "5px",
                      position: "relative",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                    align="center"
                  >
                    <strong>Completed </strong>
                  </td>
                  {/* <td
                    style={{
                      padding: "3px",
                      fontSize: "14px",
                      paddingTop: "5px",
                      position: "relative",
                      border: "1px solid #399BFF",
                    }}
                    valign="top"
                    align="center"
                  >
                    <strong>FRONT DESK </strong>
                  </td> */}
                </tr>
              </tbody>
            </table>
            {/* <br /> */}

            <table>
              <tr>
                <td>
                  <div className="common_template_footer_container">
                    <div style={{ fontFamily: '"Roboto", sans-serif' }}>
                      <div
                        style={{
                          marginBottom: "0px",
                          marginTop: "3px",
                          fontFamily: "arial black",
                          fontSize: "13px",
                        }}
                      >
                        <label style={{}}>Job Title</label>
                      </div>
                      <p
                        style={{
                          marginTop: "0px",
                          marginBottom: "0px",
                          fontSize: "13px",
                        }}
                      >
                        Checked central AC and heating system.
                        <br />
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <br />

            <table>
              <tr>
                <td>
                  <div className="common_template_footer_container">
                    <div style={{ fontFamily: '"Roboto", sans-serif' }}>
                      <div
                        style={{
                          marginBottom: "0px",
                          marginTop: "3px",
                          fontFamily: "arial black",
                          fontSize: "13px",
                        }}
                      >
                        <label style={{}}>Job Description</label>
                      </div>
                      <p
                        style={{
                          marginTop: "0px",
                          marginBottom: "0px",
                          fontSize: "13px",
                        }}
                      >
                        At vero eos et accusamus et iusto odio dignissimos
                        ducimus qui blanditiis praesentium voluptatum deleniti
                        atque corrupti quos dolores et quas molestias excepturi
                        sint occaecati cupiditate non provident, similique sunt
                        in culpa qui officia deserunt mollitia animi, id est
                        laborum et dolorum fuga. Et harum quidem rerum facilis
                        est et expedita distinctio.
                        <br />
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <br />

            <table
              className="cusm_table_conent_1"
              style={{
                borderCollapse: "collapse",
                width: "100%",
                border: "1px solid black",
              }}
              cellSpacing={0}
              cellPadding={5}
            >
              <tbody>
                <tr style={{}}>
                  <th
                    style={{
                      border: "1px solid black",
                      textAlign: "center",
                      fontWeight: "600",
                    }}
                  >
                    ITEM DETAILS
                  </th>
                  <th
                    style={{
                      border: "1px solid black",
                      textAlign: "center",
                      fontWeight: "600",
                    }}
                  >
                    QTY
                  </th>
                  <th
                    style={{
                      border: "1px solid black",
                      textAlign: "center",
                      fontWeight: "600",
                    }}
                  >
                    DISCOUNT&nbsp;(USD)
                  </th>
                  <th
                    style={{
                      border: "1px solid black",
                      textAlign: "center",
                      fontWeight: "600",
                    }}
                  >
                    LINE&nbsp;TOTAL&nbsp;(USD)
                  </th>
                </tr>
                <tr style={{}}>
                  <td
                    style={{
                      border: "1px solid black",
                      textAlign: "left",
                      fontSize: "13px",
                      lineHeight: "17px",
                    }}
                  >
                    Installed thermostat wall plate
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    3
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    50.00
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    14,950.00
                  </td>
                </tr>

                <tr style={{}}>
                  <td
                    style={{
                      border: "1px solid black",
                      textAlign: "left",
                      fontSize: "13px",
                      lineHeight: "17px",
                    }}
                  >
                    Re-wired low volt in to new one
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    1
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    25.00
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    3,475.00
                  </td>
                </tr>

                <tr style={{}}>
                  <td
                    style={{
                      border: "1px solid black",
                      textAlign: "left",
                      fontSize: "13px",
                      lineHeight: "17px",
                    }}
                  >
                    Replaced new digital thermostat
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    2
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    2%
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    4,900.00
                  </td>
                </tr>

                <tr style={{}}>
                  <td
                    style={{
                      border: "1px solid black",
                      textAlign: "left",
                      fontSize: "13px",
                      lineHeight: "17px",
                    }}
                  >
                    Programed thermostat in to heat pump mode
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    1
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    25.00
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    4,275.00
                  </td>
                </tr>

                <tr style={{}}>
                  <td
                    style={{
                      border: "1px solid black",
                      textAlign: "left",
                      fontSize: "13px",
                      lineHeight: "17px",
                    }}
                  >
                    Checked central air conditioning unit
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    1
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    50.00
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    1,850.00
                  </td>
                </tr>
                {/* <tr style={{ background: "white" }}>
                  <td
                    style={{
                      borderTop: "none",
                      borderBottom: "none",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                      fontSize: "13px",
                      lineHeight: "17px",
                    }}
                    valign="top"
                    align="left"
                  >
                    Water Bottles
                  </td>
                  <td
                    style={{
                      borderTop: "none",
                      borderBottom: "none",
                      borderRight: "solid 1px",
                      borderLeft: "solid 1px",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                    }}
                    valign="top"
                    align="right"
                  >
                    2
                  </td>
                  <td
                    style={{
                      borderTop: "none",
                      borderBottom: "none",
                      borderRight: "solid 1px",
                      borderLeft: "solid 1px",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                    }}
                    valign="top"
                    align="right"
                  >
                    5 %
                  </td>
                  <td
                    style={{
                      borderTop: "none",
                      borderBottom: "none",
                      paddingLeft: "8px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                    }}
                    valign="top"
                    align="right"
                  >
                    360.00
                  </td>
                </tr> */}
                {/* <tr style={{ background: "white" }}>
                  <td
                    style={{
                      borderTop: "none",
                      borderBottom: "none",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                      fontSize: "13px",
                      lineHeight: "17px",
                    }}
                    valign="top"
                    align="left"
                  >
                    Water Bottles
                  </td>
                  <td
                    style={{
                      borderTop: "none",
                      borderBottom: "none",
                      borderRight: "solid 1px",
                      borderLeft: "solid 1px",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                    }}
                    valign="top"
                    align="right"
                  >
                    2
                  </td>
                  <td
                    style={{
                      borderTop: "none",
                      borderBottom: "none",
                      borderRight: "solid 1px",
                      borderLeft: "solid 1px",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                    }}
                    valign="top"
                    align="right"
                  >
                    -{" "}
                  </td>
                  <td
                    style={{
                      borderTop: "none",
                      borderBottom: "none",
                      paddingLeft: "8px",
                      paddingTop: "5px",
                      paddingBottom: "5px",
                    }}
                    valign="top"
                    align="right"
                  >
                    400.00
                  </td>
                </tr> */}
                {/*            summery */}
                <tr style={{ backgroundColor: "#e1e1e1" }}>
                  <td
                    style={{ border: "1px solid black", textAlign: "right" }}
                    colSpan={3}
                  >
                    <h4 style={{ marginTop: "0px", marginBottom: "0px" }}>
                      <strong
                        style={{
                          fontSize: "16px",
                          fontSize: "16px",
                          fontWeight: "700",
                        }}
                      >
                     Total before Discount
                      </strong>
                    </h4>
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    <h4 style={{ marginTop: "0px", marginBottom: "0px" }}>
                      <strong
                        style={{
                          fontSize: "16px",
                          fontSize: "16px",
                          fontWeight: "700",
                        }}
                      >
                        20,660.00
                      </strong>
                    </h4>
                  </td>
                </tr>
                <tr style={{}}>
                  <td
                    style={{ border: "1px solid black", textAlign: "right" }}
                    colSpan={3}
                  >
                    <h4
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      Discount
                    </h4>
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    <h4
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      10.00
                    </h4>
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#e1e1e1" }}>
                  <td
                    style={{ border: "1px solid black", textAlign: "right" }}
                    colSpan={3}
                  >
                    <h4 style={{ marginTop: "0px", marginBottom: "0px" }}>
                      <strong
                        style={{
                          fontSize: "16px",
                          fontSize: "16px",
                          fontWeight: "700",
                        }}
                      >
                     Total after Discount
                      </strong>
                    </h4>
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    <h4 style={{ marginTop: "0px", marginBottom: "0px" }}>
                      <strong
                        style={{
                          fontSize: "16px",
                          fontSize: "16px",
                          fontWeight: "700",
                        }}
                      >
                       27,977.50
                      </strong>
                    </h4>
                  </td>
                </tr>
                <tr style={{}}>
                  <td
                    style={{ border: "1px solid black", textAlign: "right" }}
                    colSpan={3}
                  >
                    <h4
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      Service Charge
                    </h4>
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    <h4
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      2,797.70
                    </h4>
                  </td>
                </tr>
                <tr style={{}}>
                  <td
                    style={{ border: "1px solid black", textAlign: "right" }}
                    colSpan={3}
                  >
                    <h4
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                     Tax
                    </h4>
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    <h4
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                   2,797.70
                    </h4>
                  </td>
                </tr>
                <tr style={{ backgroundColor: "#e1e1e1" }}>
                  <td
                    style={{ border: "1px solid black", textAlign: "right" }}
                    colSpan={3}
                  >
                    <h4 style={{ marginTop: "0px", marginBottom: "0px" }}>
                      <strong style={{ fontSize: "16px", fontWeight: "700" }}>
                      Invoice Total
                      </strong>
                    </h4>
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    <h4 style={{ marginTop: "0px", marginBottom: "0px" }}>
                      <strong style={{ fontSize: "16px", fontWeight: "700" }}>
                      33,572.90
                      </strong>
                    </h4>
                  </td>
                </tr>
                <tr style={{}}>
                  <td
                    style={{ border: "1px solid black", textAlign: "right" }}
                    colSpan={3}
                  >
                    <h4 style={{ marginTop: "0px", marginBottom: "0px" }}>
                      <strong style={{ fontSize: "16px", fontWeight: "700" }}>
                        Total Due
                      </strong>
                    </h4>
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    <h4 style={{ marginTop: "0px", marginBottom: "0px" }}>
                      <strong style={{ fontSize: "16px", fontWeight: "700" }}>
                        0.00
                      </strong>
                    </h4>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* <br /> */}
          {/*<br>*/}
          <br />
          <div className="common_template_footer_container">
            <div style={{ fontFamily: '"Roboto", sans-serif' }}>
              <br />
              <div
                style={{
                  marginBottom: "0px",
                  marginTop: "3px",
                  fontFamily: "arial black",
                  fontSize: "13px",
                }}
              >
                <label style={{}}>Notes</label>
              </div>
              <p
                style={{
                  marginTop: "0px",
                  marginBottom: "0px",
                  fontSize: "13px",
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
                <br />
              </p>
            </div>
          </div>

          {/* <br /> */}
          <div className="common_template_footer_container">
            <div style={{ fontFamily: '"Roboto", sans-serif' }}>
              <br />
              <div
                style={{
                  marginBottom: "0px",
                  marginTop: "3px",
                  fontFamily: "arial black",
                  fontSize: "13px",
                }}
              >
                <label style={{}}>Warnings and Suggestions</label>
              </div>
              <p
                style={{
                  marginTop: "0px",
                  marginBottom: "0px",
                  fontSize: "13px",
                }}
              >
                At vero eos et accusamus et iusto odio dignissimos ducimus qui
                blanditiis praesentium voluptatum deleniti atque corrupti quos
                dolores et quas molestias excepturi sint occaecati cupiditate
                non provident, similique sunt in culpa qui officia deserunt
                mollitia animi, id est laborum et dolorum fuga. Et harum quidem
                rerum facilis est et expedita distinction.
                <br />
              </p>
            </div>
          </div>

          {/* ++ */}
          {/* <br /> */}
          {/*<img width="100%" height="4px" src="colout-bar.png"/>*/}
        </div>
        {/*</div>*/}
        {/*</div>*/}
        {/* <p style={{position: "fixed", bottom: 0px, display: table, margin-left: auto, margin-right: auto, width:100%, text-align: center, font-size: 12px}}>
        Powered By Smart ePoint. | 0112 95 48 48
    </p> */}
        <br />
      </div>
    </div>
  );
}
export default InvoiceView;
